import auth from './auth.js'

const TenantReducer = (state = auth.GetCredential(), action) => {
  switch (action.type) {
    case "StoreTenantInformation":
      state = {
        login                 :action.payload.LoginLogo,
        dashboard             :action.payload.DashboardLogo,
        report                :action.payload.ReportLogo,
        coverage_city         :action.payload.CoverageCity,
        in_active_site_status :action.payload.InActiveSiteStatus,
      };
      auth.WriteCredential(state)
    break;

    case "UpdateTenantCoverage":
      state = {
        login         :auth.GetCredential().login,
        dashboard     :auth.GetCredential().dashboard,
        report        :auth.GetCredential().report,
        coverage_city :action.payload
      };
      auth.WriteCredential(state)
    break

    case "UpdateTenantLogoLoginSession":
      state = {
        login     :action.payload,
        dashboard :auth.GetCredential().dashboard,
        report    :auth.GetCredential().report,
        coverage_city :auth.GetCredential().coverage_city
      };
      auth.WriteCredential(state)
    break;

    case "UpdateTenantLogoDashboardSession":
      state = {
        login     :auth.GetCredential().login,
        dashboard :action.payload,
        report    :auth.GetCredential().report,
        coverage_city :auth.GetCredential().coverage_city
      };
      auth.WriteCredential(state)
    break;

    case "UpdateTenantLogoReportSession":
      state = {
        login     :auth.GetCredential().login,
        dashboard :auth.GetCredential().dashboard,
        report    :action.payload,
        coverage_city :auth.GetCredential().coverage_city,
      };
      auth.WriteCredential(state)
    break;

    case "UpdateAllTenantSession":
      state = {
        login                 :action.payload.LoginLogo,
        dashboard             :action.payload.DashboardLogo,
        report                :action.payload.ReportLogo,
        coverage_city         :action.payload.CoverageCity,
        in_active_site_status :action.payload.InActiveSiteStatus,
      };
      auth.WriteCredential(state)
    break;

  default:
    break;
  }
  return state;
}

export default TenantReducer;



// WEBPACK FOOTER //
// ./src/App/store/tenant/index.js